"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionsToolbar = void 0;
var bulk_actions_toolbar_component_1 = require("./bulk-actions-toolbar.component");
Object.defineProperty(exports, "BulkActionsToolbar", { enumerable: true, get: function () { return bulk_actions_toolbar_component_1.BulkActionsToolbar; } });
